import React from 'react';
import Typing from 'react-typing-animation';

function About() {
  return (
    <div>
    	<Typing speed={10}>
            <p>Hey! Im Boris</p>
            <p> Software Engineer at <a href="https://www.justcode.com">JustCode</a> and <a href="https://turntotech.io/">TurnToTech</a> </p>
            <p> Holding degree of Master of Science in Computer Science</p>
            <p> From St.Xavier's College, Kolkata, West Bengal </p>
          </Typing>
    </div>
  );
}

export default About;
